import AntIcon from '@ant-design/icons'

export const Icon = AntIcon
